import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cdf28b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout-main" }
const _hoisted_3 = { class: "layout-right-other" }
const _hoisted_4 = { class: "layout-right-page" }

import layoutHeader from './components/header.vue'
import { ref, onMounted } from 'vue'
import { useMainStore } from '@/stores/main'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { getPermission } from '@/api/myProfile'
import { IMenuParams } from '@/types/myProfile'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'index-noleft',
  setup(__props) {

const route = useRoute()

// 面包屑、菜单
const store = useMainStore()
const { breadcrumb, menuInfo, filterMenu, activeMenu } = storeToRefs(store)

const isFoldFun = (val: any) => {
  isFold.value = val
}
// 过滤隐藏菜单
const filterHiddenMenu = (data: any) => {
  if (!data) return []
  return data.filter((item: any) => {
    if (item.meta.status === 1) {
      item.children = filterHiddenMenu(item.children)
    }
    return item.meta.status === 1
  })
}
// 获取菜单信息
const getMenuInfo = () => {
  getPermission().then(async (res: any) => {
    if (res.code === 200) {
      const menu: IMenuParams[] = res.data && res.data.menu ? [...res.data.menu] : []
      filterMenu.value = await flattenMenuFun(res.data.menu)
      menuInfo.value = await filterHiddenMenu(menu)
      // 当前选中active和面包屑
      filterMenu.value.forEach((element: any) => {
        if (route.path === element.path) {
          activeMenu.value = element.breadcrumbList[0].name
          breadcrumb.value = element.breadcrumbList
        }
      })
    } else {
      ElMessage(res.msg)
    }
  })
}

onMounted(() => {
  if (store.menuInfo && !store.menuInfo.length) {
    getMenuInfo()
  }
})

// 扁平化菜单
const filterMenuList: any = []
const flattenMenuFun = async (menu: any, bread?: any) => {
  for (let i = 0; i < menu.length; i++) {
    const element = menu[i]
    if (!element.breadcrumbList) {
      element.breadcrumbList = []
    }
    if (bread) {
      element.breadcrumbList.push(...bread)
    }
    element.meta.name = element.name // 用作头部默认选中
    element.meta.reload = true
    element.breadcrumbList.push(element.meta)
    if (element.children) {
      await flattenMenuFun(element.children, element.breadcrumbList)
    } else {
      filterMenuList.push(element)
    }
  }
  return filterMenuList
}

// 菜单收缩
const isFold = ref<boolean>(false)


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(layoutHeader, { onIsFold: isFoldFun }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createBlock(_component_router_view, {
            key: _unref(route).fullPath
          }))
        ])
      ])
    ])
  ]))
}
}

})